module.exports = __webpack_public_path__ + "img/collect001.1baf56a9.jpg";